import { RecordableStatusName } from "./index";

export class SearchRecordablesViewModel {
    public marketId: number;
    public communityIds: number[];
    public lotIds: number[];
    public recordableCategoryIds: number[];
    public ownerIds: number[];
    public tradePartnerIds: number[];
    public recordableStatus: RecordableStatusName;
    public recordableStatusFilter: string;
    public startDate: Date;
    public endDate: Date;
}
